export const mensajesInbox = {
  title: "Messages",

  noAccess: {
    description:
      "Pour accéder à la boîte de réception des messages, vous devez avoir votre propre numéro WhatsApp Business connecté depuis les paramètres de votre compte.",
    connectButton: "Connecter WhatsApp",
  },

  search: {
    placeholder: "Rechercher par téléphone ou par client...",
  },

  filters: {
    allProperties: "Tous les logements",
    searchProperty: "Rechercher un logement...",
    filterTitle: "Filtrer les messages",
    clearAll: "Effacer les filtres",
    removeOne: "Retirer « {filtro} »",
    someActive: "{count} filtres",
  },

  tabs: {
    all: "Tous",
    unread: "Non lus",
    pinned: "Épinglés",
    archived: "Archivés",
    noReservation: "Sans réservation",
    otaBooking: "Booking.com",
    otaAirbnb: "Airbnb",
    otaExpedia: "Expedia",
    otaOther: "Autre OTA",
    unpaid: "Impayées",
    paid: "Payées",
    arrivingSoon: "Arrivent bientôt",
  },

  filterGroups: {
    chat: "Conversation",
    origin: "Origine",
    reservation: "Réservation",
  },

  list: {
    empty: "Aucune conversation",
    noMessages: "Aucun message",
  },

  channels: {
    web: "Web",
    webConcierge: "Conciergerie web · Portail du séjour",
    otaMessage: "Message {provider}",
  },

  chat: {
    placeholderSelect: "Sélectionnez une conversation pour commencer",
    loading: "Chargement de la conversation...",
    dropToAttach: "Déposez ici pour joindre des fichiers",
    emptyThread: "Aucun message dans ce fil pour le moment",
    notSent: "Non envoyé",
    sending: "Envoi...",
  },

  sender: {
    guest: "Client",
    you: "Vous",
    aiAgent: "Agent IA",
  },

  media: {
    document: "Document",
    sharedLocation: "Position partagée",
    attachment: "Pièce jointe",
  },

  preview: {
    attachmentSent: "Pièce jointe envoyée",
    messageSent: "Message envoyé",
    attachmentReceived: "Pièce jointe reçue",
    newMessage: "Nouveau message",
  },

  mode: {
    aiAgent: "Agent IA",
    manual: "Manuel",
  },

  automation: {
    disabledNotice:
      "L'Agent IA n'est pas activé pour ce logement : il ne répondra pas, c'est vous qui écrivez les messages.",
    aiActiveBanner:
      "L'agent IA répond automatiquement à ce client.",
  },

  faq: {
    title: "Questions fréquentes",
  },

  composer: {
    placeholder: "Saisissez un message ou utilisez / pour insérer une réponse...",
    hint: "Entrée pour envoyer · Maj+Entrée pour un saut de ligne",
  },

  actions: {
    newConversation: "Nouvelle conversation",
    options: "Options",
    attachFile: "Joindre un fichier",
  },

  alt: {
    flag: "Drapeau",
    sentImage: "Image envoyée",
  },

  common: {
    file: "fichier",
    notAvailable: "Non disponible",
  },

  nights: "{count} nuit | {count} nuits",

  arrival: {
    pending: "Date en attente",
    today: "Arrive aujourd'hui",
    tomorrow: "Arrive demain",
    yesterday: "Arrivé hier",
    inDays: "Dans {count} jours",
    daysAgo: "Arrivé il y a {count} jours",
  },

  reservationStatus: {
    booked: "Confirmée",
    cancelled: "Annulée",
    pending: "En attente",
    checked_in: "Arrivée effectuée",
    checked_out: "Départ effectué",
  },

  reservationPanel: {
    title: "Réservation liée",
    stayEnded: "Le client ne séjourne plus ici",
    checkIn: "Arrivée",
    checkOut: "Départ",
    room: "Chambre",
    reservation: "Réservation",
    phone: "Téléphone",
    viewReservation: "Voir la réservation",
    noReservationTitle: "Aucune réservation liée",
    noReservationOta:
      "Ce fil provient de {channel} via Channex et n'est pas encore lié à une réservation locale.",
    noReservationWhatsapp:
      "Ce contact a écrit au WhatsApp connecté mais n'est pas encore lié à une réservation.",
    assignReservation: "Attribuer une réservation",
    createReservation: "Créer une réservation",
    assignExisting: "Attribuer une réservation existante",
    searchPlaceholder: "Rechercher par nom ou par code...",
    noReservationsFound: "Aucune réservation trouvée",
    placeholderContext: "Sélectionnez une conversation pour voir le contexte",
    propertyUnavailable: "Logement indisponible",
  },

  contextMenu: {
    pin: "Épingler la conversation",
    unpin: "Désépingler la conversation",
    archive: "Archiver la conversation",
    unarchive: "Désarchiver la conversation",
  },

  waStatus: {
    read: "Lu",
    delivered: "Distribué",
    queued: "En file d'attente",
    failed: "Échec",
    sent: "Envoyé",
  },

  waFailTitle: {
    noWhatsapp: "Pas de WhatsApp",
    invalidNumber: "Numéro invalide",
    notSent: "Non envoyé",
  },

  waErrors: {
    generic: "Ce message n'a pas pu être envoyé via WhatsApp.",
  },

  waErrorShort: {
    e131042: "problème de paiement sur le compte WhatsApp",
    e131026: "le numéro ne peut pas recevoir de messages WhatsApp",
    e131053: "WhatsApp n'a pas pu télécharger le fichier",
    e132000: "données manquantes dans le modèle",
    e131009: "le message ne répond pas aux exigences de WhatsApp",
  },

  toasts: {
    aiActiveSwitchManual:
      "L'agent IA est actif. Passez en mode manuel pour répondre.",
    pinned: "Conversation épinglée",
    unpinned: "Conversation désépinglée",
    archived: "Conversation archivée",
    unarchived: "Conversation désarchivée",
    reservationAssigned: "Réservation attribuée : {name}",
    reservationUnassigned: "Réservation dissociée",
    selectPropertyToCreate:
      "Sélectionnez un logement pour créer la réservation à partir de cette conversation.",
    userNotResolved: "Impossible de déterminer l'utilisateur du panneau.",
    aiNotEnabledConfig:
      "Ce logement n'a pas l'Agent IA activé. Activez-le depuis les paramètres de l'annonce.",
    aiEnabledForChat: "Agent IA activé pour cette conversation",
    manualEnabledForChat: "Mode manuel activé pour cette conversation",
    templateSent: "Modèle envoyé avec succès.",
  },

  errors: {
    inboxNotActive:
      "La boîte de réception des messages n'est pas active pour ce compte, ou le WhatsApp professionnel doit encore être connecté.",
    openConversation: "Impossible d'ouvrir la conversation",
    sendMessage: "Impossible d'envoyer le message. Vérifiez votre connexion WhatsApp.",
    pin: "Erreur lors de l'épinglage de la conversation",
    archive: "Erreur lors de l'archivage",
    loadReservations: "Erreur lors du chargement des réservations",
    assignReservation: "Erreur lors de l'attribution de la réservation",
    unassignReservation: "Erreur lors de la dissociation de la réservation",
    updateMode: "Impossible de mettre à jour le mode pour cette conversation",
    reactivationTemplate: "Impossible d'envoyer le modèle de réactivation.",
  },
};
